export const getRpcFallbackUrls = (configuredRpcUrl: string | undefined, networkRpcUrl: string) =>
  [configuredRpcUrl, networkRpcUrl].filter(
    (rpcUrl, index, rpcUrls): rpcUrl is string => Boolean(rpcUrl) && rpcUrls.indexOf(rpcUrl) === index,
  )
